<div class class="baukosten-container-outer-div" id='baukostenContainer'
    style="overflow-x: auto;white-space: nowrap;">

    @if (planIdFilter !== null) {
      <div class="plan-filter-banner">
        <span class="plan-filter-text">{{ labelFilteredBy }} <strong>{{ planFilterLabel }}</strong></span>
        <app-gpd-button
          type="tertiary"
          [text]="labelShowAll"
          (onClick)="clearPlanFilter()">
        </app-gpd-button>
      </div>
    }

    <dx-data-grid
        class="baukosten-grid-container gt-data-grid-style project-cost-grid "
        [dataSource]="baukosten"
        [remoteOperations]="false" [allowColumnReordering]="true"
        [rowAlternationEnabled]="true" #dataGrid
        [keyExpr]="'paymentPlanId'" [wordWrapEnabled]="true"
        (onCellDblClick)="editProjektKosten($event)"
        (onContentReady)="onGridContentReady($event)"
        [noDataText]="noData" useNative="false" showScrollbar="always"
        (onOptionChanged)="onGridOptionChanged($event)"
        [searchPanel]="{searchVisibleColumnsOnly:true,text:searchTerm,highlightSearchText:true}"
        [allowColumnResizing]="true" [columnResizingMode]="'widget'"
        [columnAutoWidth]="false" [showBorders]="true"
        [scrolling]="{ mode: 'standard', useNative: true }" [width]="'100%'"
        [hoverStateEnabled]="true" height="100%"
        [(selectedRowKeys)]="selectedRowKeys">
        <dxo-selection mode="single"></dxo-selection>
        <dxo-row-dragging [allowReordering]="false" [onReorder]="onReorder"
            [showDragIcons]="true">
        </dxo-row-dragging>
        <dxo-paging [enabled]="false"> </dxo-paging>
        <!-- Widget-specific tag on purpose: DevExtreme 26.1 has per-widget nested selectors
             and a mismatched one renders nothing without any build error. The column set below
             is not covered by a test - project-costs-header-filter.spec.ts pins the tag and the
             allowHeaderFiltering contract on a stand-in grid, not on this template. -->
        <dxo-data-grid-header-filter [visible]="true" [allowSearch]="true">
        </dxo-data-grid-header-filter>
        <dxo-search-panel [visible]="true"
            class="gt-search-panel margin-top-toolbar-header"
            width="17vw" i18n-placeholder="@@projectCostsSearch" placeholder="Search project costs..."></dxo-search-panel>
        <dxo-toolbar width="100%">
            <dxi-item width="100%" name="searchPanel" location="before"
                style="margin-top: 78px;"
                class="margin-top-toolbar-header"></dxi-item>
            <dxi-item [width]="'100%'" location="center"
                class="margin-top-toolbar-header">
                <div class="toolbar-center-container"
                    id="baukostenHeaderContainerId">
                    <div class="calculation-data-container">
                        <!--                    <label class="textbox-label" >{{this.plantsizetext + this.sizeSource + ': ' +
                            this.headerTitles.groesse + '
                            kWp'}}</label>
                        <label class="textbox-label" >{{this.techProjManagerText +
                            this.headerTitles.projektleiter}}</label> -->
                        <label class="textbox-label"
                            i18n="@@perSizeUnitTotalCaps">{{ perUnitLabel(sizeUnit) }} TOTAL:
                            {{ istKostenkWp }}</label>
                        <label class="textbox-label" i18n="@@netTotalCaps">NETT
                            TOTAL: {{istNetto}}</label>
                        <label class="textbox-label"
                            i18n="@@grossTotalCaps">GROSS TOTAL:
                            {{brutto}}</label>
                        <label class="textbox-label" i18n="@@paidCaps">PAID:
                            {{bezahlt}} ({{bezahltPercentage}})
                        </label>
                        <label class="textbox-label"
                            i18n="@@outstandingCaps">OUTSTANDING:
                            {{aussterhand}}
                            ({{aussterhandPercentage}})
                        </label>
                    </div>
                </div>
            </dxi-item>

            <dxi-item width="100%" location="after">
                <div class="gt-flex-dir-row" style="gap:8px">
                    <app-gpd-segmented-switch
                        [options]="beauftragtOptions"
                        [value]="beauftragtFilter"
                        (valueChange)="setBeauftragtFilter($event)"></app-gpd-segmented-switch>

                    <app-gpd-segmented-switch
                        [options]="openOptions"
                        [value]="openFilter"
                        (valueChange)="setOpenFilter($event)"></app-gpd-segmented-switch>

                    <app-gpd-button
                        type="tertiary"
                        i18n-text="@@export"
                        text="Export" icon="download"
                        (onClick)="exportAsExcel($event)"></app-gpd-button>

                    <app-gpd-button [disabled]="!buttonDisabled"
                        i18n-text="@@addCosts" text="Add Costs" icon="add"
                        (onClick)="addCost()"></app-gpd-button>
                </div>
            </dxi-item>
            <!--      <dxi-item>
          <dx-text-box [value]="searchValue" [showClearButton]="true" i18n-placeholder="@@search ..."
                placeholder="Search ..." valueChangeEvent="keyup" (onValueChanged)="searchValueChanged($event)">
            </dx-text-box>
        </dxi-item> -->
        </dxo-toolbar>

        <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" dataField="primaryCostCategoryName"
            [groupIndex]="0" 
            groupCellTemplate="groupCellTemplate"></dxi-column>
        <div *dxTemplate="let data of 'groupCellTemplate'">
            {{data.key}}
        </div>
        <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true"  dataField="paymentPlanId"
            caption="ID" dataType="string"
            [allowSearch]="true"></dxi-column>
        <dxi-column [allowResizing]="true" dataField="costCategoryName"
            i18n-caption [sortIndex]="1" sortOrder="asc"
            dataType="string" [allowSearch]="true" [allowHeaderFiltering]="true"
            caption="Cost Type"></dxi-column>
        <dxi-column [allowResizing]="true" dataField="debitorName"
            dataType="string" i18n-caption caption="Debitor"
            [customizeText]="debitorCellText" [allowHeaderFiltering]="true"
            [allowEditing]="false" [allowSearch]="true"></dxi-column>
        <dxi-column [allowResizing]="true" dataField="planNotes" i18n-caption
            caption="Details" [allowHeaderFiltering]="true"
            [allowSearch]="true"></dxi-column>
        <dxi-column [allowResizing]="true" dataField="planNrText" i18n-caption
            [allowSearch]="true" dataType="string" [allowHeaderFiltering]="true"
            caption="More Details"></dxi-column>
        <dxi-column [allowResizing]="true" dataField="partnerName" i18n-caption
            [allowSearch]="true" dataType="string" [allowHeaderFiltering]="true"
            [sortIndex]="2" sortOrder="asc"
            caption="Service Provider"></dxi-column>
        <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" i18n-caption caption="Costs"
            [allowSearch]="true">
            <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true"
                dataField="planEuroPerKilowattPeak" [caption]="perUnitLabel(sizeUnit)"
                dataType="string"
                [allowSearch]="true" format="#,##0.00 €"
                [allowEditing]="false"></dxi-column>
            <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" dataField="planCostNettDisplay"
                i18n-caption dataType="string"
                [allowSearch]="true" caption="Nett"
                format="#,##0.00 €"></dxi-column>
            <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" dataField="planPercentage"
                dataType="string"
                i18n-caption="@@percentPortion" [allowSearch]="true"
                caption="% Portion"
                format="#,##0.# %"></dxi-column>
            <!--                         <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" dataField="nettoBrutto" caption="Netto / Brutto" [contentEditable]="true" (onValueChanged)="handleOptionChange($event)">
                            <dxo-lookup [dataSource]="statuses" displayExpr="name" valueExpr="name">
                            </dxo-lookup>
                        </dxi-column> -->
            <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" dataField="planUst" i18n-caption
                caption="USt" dataType="string"
                [allowSearch]="true" format="#,##0.# %"> </dxi-column>
            <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" dataField="planCostGross"
                i18n-caption caption="Gross" dataType="string"
                [allowSearch]="true" format="#,##0.00 €"
                [allowEditing]="false"></dxi-column>
        </dxi-column>

        <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" i18n-caption caption="Paid"
            [allowSearch]="true">
            <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" dataField="paidAmountNett"
                i18n-caption dataType="string"
                [allowSearch]="true" caption="Nett"
                format="#,##0.00 €"></dxi-column>
            <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" dataField="paidAmountGross"
                i18n-caption dataType="string"
                [allowSearch]="true" caption="Amount"
                format="#,##0.00 €"></dxi-column>
            <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" dataField="discountGross"
                i18n-caption dataType="string"
                [allowSearch]="true" caption="Cash Discount"
                format="#,##0.00 €"></dxi-column>
            <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" dataField="paidDate" i18n-caption
                caption="Date" dataType="date"
                [allowSearch]="true" [format]="formatDate"
                [alignment]="'right'"></dxi-column>
        </dxi-column>

        <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" i18n-caption caption="Pending"
            [allowSearch]="true">
            <!--                          <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" dataField="nochUst" [format]="formatEuro" [allowEditing]="false"></dxi-column> -->
            <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" dataField="dueAmountNett"
                format="#,##0.00 €"
                i18n-caption="@@dueAmountNett" dataType="string"
                [allowSearch]="true" caption="Nett"
                [allowEditing]="false"></dxi-column>
            <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" dataField="dueAmountGross"
                format="#,##0.00 €"
                i18n-caption="@@dueAmountGross" dataType="string"
                [allowSearch]="true" caption="Amount"
                [allowEditing]="false"></dxi-column>
            <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" dataField="dueDate" i18n-caption
                dataType="date" [allowSearch]="true"
                caption="Planned Date" [allowEditing]="true"
                [alignment]="'right'" [format]="formatDate"></dxi-column>
        </dxi-column>

        <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" i18n-caption="@@status" caption="Status"
            alignment="center">
            <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" dataField="beauftragt"
                dataType="boolean" i18n-caption="@@commissioned" caption="Commissioned"
                [allowEditing]="false" [allowSearch]="false"></dxi-column>
            <dxi-column [allowHeaderFiltering]="true" [allowResizing]="true" dataField="invoiceNumber"
                dataType="string" i18n-caption="@@invoice" caption="Invoice"
                [headerFilter]="{ dataSource: invoiceHeaderFilter }"
                [allowEditing]="false" [allowSearch]="true"></dxi-column>
        </dxi-column>
        <dxi-column [allowHeaderFiltering]="false" [allowResizing]="true" dataField="paymentNotes" i18n-caption
            caption="Notes"
            [allowSearch]="true"></dxi-column>

        <dxo-summary class="gt-wht-txt">
            <dxi-group-item column="planEuroPerKilowattPeak" name="planEuroPerKilowattPeak"
                [alignByColumn]="true" [valueFormat]="formatEuro"
                displayFormat="{0}" summaryType="sum" class="gt-wht-txt">
            </dxi-group-item>
            <dxi-group-item column="planCostNettDisplay" name="planCostNettDisplay" [alignByColumn]="true"
                [valueFormat]="formatEuro" displayFormat="{0}"
                summaryType="sum" class="gt-wht-txt"> </dxi-group-item>
            <dxi-group-item column="planCostGross" name="planCostGross" [alignByColumn]="true"
                [valueFormat]="formatEuro" displayFormat="{0}"
                summaryType="sum" class="gt-wht-txt"> </dxi-group-item>
            <dxi-group-item column="discountGross" name="discountGross" [alignByColumn]="true"
                [valueFormat]="formatEuro" displayFormat="{0}"
                summaryType="sum" class="gt-wht-txt"> </dxi-group-item>
            <dxi-group-item column="paidAmountNett" name="paidAmountNett" [alignByColumn]="true"
                [valueFormat]="formatEuro" displayFormat="{0}"
                summaryType="sum" class="gt-wht-txt"> </dxi-group-item>
            <dxi-group-item column="paidAmountGross" name="paidAmountGross" [alignByColumn]="true"
                [valueFormat]="formatEuro"
                displayFormat="{0}" summaryType="sum" class="gt-wht-txt">
            </dxi-group-item>

            <dxi-group-item column="dueAmountNett" name="dueAmountNett" [alignByColumn]="true"
                [valueFormat]="formatEuro"
                displayFormat="{0}" summaryType="sum" class="gt-wht-txt"> </dxi-group-item>
            <dxi-group-item column="dueAmountGross" name="dueAmountGross" [alignByColumn]="true"
                [valueFormat]="formatEuro"
                displayFormat="{0}" summaryType="sum"> </dxi-group-item>
        </dxo-summary>
        <!--  <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling> -->
    </dx-data-grid>

</div>

<div class='button-container full-width'>
    <div>
        <dx-button *ngIf="onUpdateReveal&&showButtons"
            class="gt-button gt-tertiary gt-btn-left" i18n-text text="CANCEL"
            (onClick)="saveQueryOnCancel()"></dx-button>
    </div>
    <div>
        <dx-button *ngIf="onUpdateReveal&&showButtons"
            class="gt-button gt-primary gt-btn-right" i18n-text text="SAVE"
            (onClick)="initiateSaveChangesToBaukosten()"></dx-button>
    </div>
    <div>

        <!--         <dx-button [disabled]="!buttonDisabled || !editablePermission" class="gt-button gt-primary gt-btn-right"
            i18n-text text="Add Costs" (onClick)="addCost()"></dx-button> -->
        <!--                 <dx-button class="gt-button gt-secondary gt-bottom gt-btn-right" i18n-text text="EXPORT PROJECT COSTS"
                    (onClick)="exportCosts()"></dx-button>  -->
    </div>

</div>
<!--    </div> -->

<dx-toast [(visible)]="isVisible" [(type)]="type" [(message)]="message">
</dx-toast>

<dx-toast [(visible)]="isVisible" [(type)]="type" [(message)]="message"> </dx-toast>

<dx-popup *ngIf="popupActivate" [(visible)]='popupActivate' fit-content="fit-content" height="auto" maxHeight="85vh"
    minHeight="300px" [title]="currenttitle" [showTitle]="true" (onHiding)="hidePopUp()" style="padding-bottom:35px">
    <app-projektkosten-pop-up (disablePopUpWindow)="togglePopUpVisibility($event)" [categoryList]="categoryList"
        [partnerList]="partnerList" (onHiding)="togglePopUpVisibility($event)" [projectDetails]="projectCosts" [projectRoles]="projectRoles"
        [sizeUnit]="sizeUnit"
        (selectedCategoryToSend)="getSelectedCategory($event)" [milestones]="milestones" [projectMilestones]="projectMilestones"
        (onProjectAutoCompleted)="onProjectAutoCompleted()">
    </app-projektkosten-pop-up>
</dx-popup>

<app-project-complete-popup
  [(visible)]="projectCompletePopupVisible"
  [userName]="currentUserName"
></app-project-complete-popup>
